/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ParametroModelDto } from '../models/parametro-model-dto';
import { ProgramaModelDto } from '../models/programa-model-dto';
import { ProgramaParametrosModelDto } from '../models/programa-parametros-model-dto';
import { programasControllerActualizarEncuestaPrograma } from '../fn/doctor-programas/programas-controller-actualizar-encuesta-programa';
import { ProgramasControllerActualizarEncuestaPrograma$Params } from '../fn/doctor-programas/programas-controller-actualizar-encuesta-programa';
import { programasControllerActualizarPrograma } from '../fn/doctor-programas/programas-controller-actualizar-programa';
import { ProgramasControllerActualizarPrograma$Params } from '../fn/doctor-programas/programas-controller-actualizar-programa';
import { programasControllerBorrarPrograma } from '../fn/doctor-programas/programas-controller-borrar-programa';
import { ProgramasControllerBorrarPrograma$Params } from '../fn/doctor-programas/programas-controller-borrar-programa';
import { programasControllerCrearPrograma } from '../fn/doctor-programas/programas-controller-crear-programa';
import { ProgramasControllerCrearPrograma$Params } from '../fn/doctor-programas/programas-controller-crear-programa';
import { programasControllerDescargarEncuestaCancelacion } from '../fn/doctor-programas/programas-controller-descargar-encuesta-cancelacion';
import { ProgramasControllerDescargarEncuestaCancelacion$Params } from '../fn/doctor-programas/programas-controller-descargar-encuesta-cancelacion';
import { programasControllerEditarPrograma } from '../fn/doctor-programas/programas-controller-editar-programa';
import { ProgramasControllerEditarPrograma$Params } from '../fn/doctor-programas/programas-controller-editar-programa';
import { programasControllerEliminarEncuestaCancelacion } from '../fn/doctor-programas/programas-controller-eliminar-encuesta-cancelacion';
import { ProgramasControllerEliminarEncuestaCancelacion$Params } from '../fn/doctor-programas/programas-controller-eliminar-encuesta-cancelacion';
import { programasControllerListadoParametros } from '../fn/doctor-programas/programas-controller-listado-parametros';
import { ProgramasControllerListadoParametros$Params } from '../fn/doctor-programas/programas-controller-listado-parametros';
import { programasControllerObtenerPrograma } from '../fn/doctor-programas/programas-controller-obtener-programa';
import { ProgramasControllerObtenerPrograma$Params } from '../fn/doctor-programas/programas-controller-obtener-programa';
import { programasControllerObtenerProgramas } from '../fn/doctor-programas/programas-controller-obtener-programas';
import { ProgramasControllerObtenerProgramas$Params } from '../fn/doctor-programas/programas-controller-obtener-programas';
import { programasControllerObtenerProgramasMedico } from '../fn/doctor-programas/programas-controller-obtener-programas-medico';
import { ProgramasControllerObtenerProgramasMedico$Params } from '../fn/doctor-programas/programas-controller-obtener-programas-medico';

@Injectable({ providedIn: 'root' })
export class DoctorProgramasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `programasControllerCrearPrograma()` */
  static readonly ProgramasControllerCrearProgramaPath = '/api/programas/crear-programa';

  /**
   * Crear un nuevo programa.
   *
   * Permite crear un nuevo programa.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerCrearPrograma()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerCrearPrograma$Response(params: ProgramasControllerCrearPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramaModelDto>> {
    return programasControllerCrearPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * Crear un nuevo programa.
   *
   * Permite crear un nuevo programa.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerCrearPrograma$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerCrearPrograma(params: ProgramasControllerCrearPrograma$Params, context?: HttpContext): Observable<ProgramaModelDto> {
    return this.programasControllerCrearPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramaModelDto>): ProgramaModelDto => r.body)
    );
  }

  /** Path part for operation `programasControllerActualizarPrograma()` */
  static readonly ProgramasControllerActualizarProgramaPath = '/api/programas/actualizar-programa/{uuidPrograma}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerActualizarPrograma()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerActualizarPrograma$Response(params: ProgramasControllerActualizarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return programasControllerActualizarPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerActualizarPrograma$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerActualizarPrograma(params: ProgramasControllerActualizarPrograma$Params, context?: HttpContext): Observable<void> {
    return this.programasControllerActualizarPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `programasControllerActualizarEncuestaPrograma()` */
  static readonly ProgramasControllerActualizarEncuestaProgramaPath = '/api/programas/actualizar-encuesta-programa/{uuidPrograma}';

  /**
   * Actualizar encuesta de un programa.
   *
   * Actualiza la encuesta de un programa dado su UUID. Acepta un archivo Excel opcional que se convertirá a JSON.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerActualizarEncuestaPrograma()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  programasControllerActualizarEncuestaPrograma$Response(params: ProgramasControllerActualizarEncuestaPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return programasControllerActualizarEncuestaPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar encuesta de un programa.
   *
   * Actualiza la encuesta de un programa dado su UUID. Acepta un archivo Excel opcional que se convertirá a JSON.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerActualizarEncuestaPrograma$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  programasControllerActualizarEncuestaPrograma(params: ProgramasControllerActualizarEncuestaPrograma$Params, context?: HttpContext): Observable<void> {
    return this.programasControllerActualizarEncuestaPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `programasControllerEditarPrograma()` */
  static readonly ProgramasControllerEditarProgramaPath = '/api/programas/editar-programa';

  /**
   * Editar un programa existente.
   *
   * Permite editar un programa ya existente.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerEditarPrograma()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerEditarPrograma$Response(params: ProgramasControllerEditarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramaModelDto>> {
    return programasControllerEditarPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * Editar un programa existente.
   *
   * Permite editar un programa ya existente.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerEditarPrograma$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  programasControllerEditarPrograma(params: ProgramasControllerEditarPrograma$Params, context?: HttpContext): Observable<ProgramaModelDto> {
    return this.programasControllerEditarPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramaModelDto>): ProgramaModelDto => r.body)
    );
  }

  /** Path part for operation `programasControllerBorrarPrograma()` */
  static readonly ProgramasControllerBorrarProgramaPath = '/api/programas/borrar-programa/{uuidPrograma}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerBorrarPrograma()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerBorrarPrograma$Response(params: ProgramasControllerBorrarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return programasControllerBorrarPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerBorrarPrograma$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerBorrarPrograma(params: ProgramasControllerBorrarPrograma$Params, context?: HttpContext): Observable<void> {
    return this.programasControllerBorrarPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `programasControllerDescargarEncuestaCancelacion()` */
  static readonly ProgramasControllerDescargarEncuestaCancelacionPath = '/api/programas/descargar-encuesta-cancelacion/{uuidPrograma}';

  /**
   * Descargar encuesta de cancelación en Excel.
   *
   * Descarga la encuesta de cancelación de un programa en formato Excel (.xlsx)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerDescargarEncuestaCancelacion()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerDescargarEncuestaCancelacion$Response(params: ProgramasControllerDescargarEncuestaCancelacion$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return programasControllerDescargarEncuestaCancelacion(this.http, this.rootUrl, params, context);
  }

  /**
   * Descargar encuesta de cancelación en Excel.
   *
   * Descarga la encuesta de cancelación de un programa en formato Excel (.xlsx)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerDescargarEncuestaCancelacion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerDescargarEncuestaCancelacion(params: ProgramasControllerDescargarEncuestaCancelacion$Params, context?: HttpContext): Observable<Blob> {
    return this.programasControllerDescargarEncuestaCancelacion$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `programasControllerEliminarEncuestaCancelacion()` */
  static readonly ProgramasControllerEliminarEncuestaCancelacionPath = '/api/programas/eliminar-encuesta-cancelacion/{uuidPrograma}';

  /**
   * Eliminar encuesta de cancelación de un programa.
   *
   * Elimina la encuesta de cancelación de un programa dado su UUID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerEliminarEncuestaCancelacion()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerEliminarEncuestaCancelacion$Response(params: ProgramasControllerEliminarEncuestaCancelacion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return programasControllerEliminarEncuestaCancelacion(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar encuesta de cancelación de un programa.
   *
   * Elimina la encuesta de cancelación de un programa dado su UUID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerEliminarEncuestaCancelacion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerEliminarEncuestaCancelacion(params: ProgramasControllerEliminarEncuestaCancelacion$Params, context?: HttpContext): Observable<void> {
    return this.programasControllerEliminarEncuestaCancelacion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `programasControllerObtenerPrograma()` */
  static readonly ProgramasControllerObtenerProgramaPath = '/api/programas/detalle-programa/{uuidPrograma}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerObtenerPrograma()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerPrograma$Response(params: ProgramasControllerObtenerPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<ProgramaParametrosModelDto>> {
    return programasControllerObtenerPrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerObtenerPrograma$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerPrograma(params: ProgramasControllerObtenerPrograma$Params, context?: HttpContext): Observable<ProgramaParametrosModelDto> {
    return this.programasControllerObtenerPrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramaParametrosModelDto>): ProgramaParametrosModelDto => r.body)
    );
  }

  /** Path part for operation `programasControllerListadoParametros()` */
  static readonly ProgramasControllerListadoParametrosPath = '/api/programas/listado-parametros';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerListadoParametros()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerListadoParametros$Response(params?: ProgramasControllerListadoParametros$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParametroModelDto>>> {
    return programasControllerListadoParametros(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerListadoParametros$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerListadoParametros(params?: ProgramasControllerListadoParametros$Params, context?: HttpContext): Observable<Array<ParametroModelDto>> {
    return this.programasControllerListadoParametros$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ParametroModelDto>>): Array<ParametroModelDto> => r.body)
    );
  }

  /** Path part for operation `programasControllerObtenerProgramas()` */
  static readonly ProgramasControllerObtenerProgramasPath = '/api/programas/obtener-programas';

  /**
   * Obtener lista de programas.
   *
   * Obtiene una lista de programas completa.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerObtenerProgramas()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerProgramas$Response(params?: ProgramasControllerObtenerProgramas$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramaModelDto>>> {
    return programasControllerObtenerProgramas(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener lista de programas.
   *
   * Obtiene una lista de programas completa.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerObtenerProgramas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerProgramas(params?: ProgramasControllerObtenerProgramas$Params, context?: HttpContext): Observable<Array<ProgramaModelDto>> {
    return this.programasControllerObtenerProgramas$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramaModelDto>>): Array<ProgramaModelDto> => r.body)
    );
  }

  /** Path part for operation `programasControllerObtenerProgramasMedico()` */
  static readonly ProgramasControllerObtenerProgramasMedicoPath = '/api/programas/programas-medico';

  /**
   * Obtener programas asignados al médico autenticado.
   *
   * Devuelve la lista de programas asignados al médico identificado autenticado
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `programasControllerObtenerProgramasMedico()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerProgramasMedico$Response(params?: ProgramasControllerObtenerProgramasMedico$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProgramaModelDto>>> {
    return programasControllerObtenerProgramasMedico(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener programas asignados al médico autenticado.
   *
   * Devuelve la lista de programas asignados al médico identificado autenticado
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `programasControllerObtenerProgramasMedico$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  programasControllerObtenerProgramasMedico(params?: ProgramasControllerObtenerProgramasMedico$Params, context?: HttpContext): Observable<Array<ProgramaModelDto>> {
    return this.programasControllerObtenerProgramasMedico$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramaModelDto>>): Array<ProgramaModelDto> => r.body)
    );
  }

}
